var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_2318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.125 0H104.98V11.2305H89.3555V22.4609H104.98V33.6914H78.125V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.352 0H137.207V9.76562H121.582V11.7188H137.207V34.1797H110.352V23.9258H125.977V21.9727H110.352V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.578 0H169.434V9.76562H153.809V11.7188H169.434V34.1797H142.578V23.9258H158.203V21.9727H142.578V0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.422 229.892L213.558 49.1307H36.4419L52.5605 229.92L124.892 250L197.422 229.892ZM183.608 218.382L197.397 63.9129H125V86.4583H69.7752L70.8169 108.333H125V131.25H72.9002L76.0252 153.125H125V188.538L124.984 188.542L99.9836 182.292L98.9419 164.583H76.0252L79.1502 198.958L124.984 211.458L125 211.454V234.63L183.608 218.382Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.397 63.913L183.608 218.382L125 234.63V211.454L170.817 198.958L180.192 86.4583H125V63.913H197.397ZM125 108.333V131.25H154.15L156.233 108.333H125ZM125 188.538L149.983 182.292L152.067 153.125H125V188.538Z",
    fill: "current",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_2318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177.116,
    height: 250,
    fill: "current",
    transform: "translate(36.4419)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsCss);
export default __webpack_public_path__ + "static/media/skills-css.08dc3187a2f299e2e312c0ab90d3b0c4.svg";
export { ForwardRef as ReactComponent };